import { MouseEvent } from 'react'

export const getDocumentHeight = () => document.documentElement.offsetHeight

export const isDimmedClick = (e: MouseEvent<Element>, className: string) => {
  const { target } = e

  return (target as any).classList.contains(className)
}

export const scrollTo = (x: number, y: number) => window.scrollTo(x, y)

export const scrollToTop = (offset: number) => scrollTo(0, offset)

export const scrollToBottom = () => scrollTo(0, getDocumentHeight())
